import axios from "axios";

const baseURL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_API_URL
    : "/api";  

const api = axios.create({
  baseURL,
  withCredentials: true
});

export default api;
